// ============================================================================
// useFilterExport.ts
// Handle export functionality
// ============================================================================

import { useState, useCallback } from "react";
import { commonService } from "@/api/common/common.service";
import { buildQueryParams } from "@/utils/commonUtils";
import { PAGE_LIMIT_TEN } from "@/core/const";
import { useToast } from "@/components/ui";
import { downloadBase64File } from "@/utils/downloadFile";

export const useFilterExport = () => {
  const [isExporting, setIsExporting] = useState(false);
  const { toast } = useToast();
  const handleExport = useCallback(
    async (format: string) => {
      setIsExporting(true);
      const params = {
        is_active: true,
        page_type: "user",
        page: 1,
        page_size: PAGE_LIMIT_TEN,
        location: "",
        scope: "all",
        export_format: format?.toLowerCase(),
      };
      const query = buildQueryParams(params);

      try {
        const res = await commonService.getExcelExport(query);
        const { file_name, file_data } = res.data;

        if (!file_name || !file_data) {
          throw new Error("Invalid export data: missing required fields");
        }

        downloadBase64File(file_name, file_data);
        toast({
          variant: "green",
          title: res.message ?? "Users exported successfully.",
        });
      } catch (e) {
        console.error("Export failed", e);
        toast({
          variant: "destructive",
          title: e instanceof Error ? e.message : "Failed to export users.",
        });
      } finally {
        setIsExporting(false);
      }
    },
    [toast],
  );

  return { isExporting, handleExport };
};
